// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3p05L","cell":"ColumnAccessor_cell__37wNf","firstCellAccent":"ColumnAccessor_firstCellAccent__2hSi0"};